import { render, staticRenderFns } from "./il-flag.vue?vue&type=template&id=495b6d26&scoped=true&"
import script from "./il-flag.vue?vue&type=script&lang=js&"
export * from "./il-flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495b6d26",
  null
  
)

export default component.exports